<script lang="ts" setup>
import { computed } from 'vue';
import { NotificationShareSurveyType } from '@/types';
import CardTemplate from './card-template.vue';

interface Props {
  notification: NotificationShareSurveyType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() => {
  return `/share_surveys/${props.notification.share_survey.uuid}`;
});
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :image-url="notification.creator_image_url"
    :content-title="notification.share_survey.title"
  >
    {{ notification.creator_name }}さんからシェアスレッドが共有されました。
  </CardTemplate>
</template>
